import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import { translateTransaction } from "@qgiv/core-donor";
import { selectReceipt } from "../../../redux/slices/receiptSlice";
import { selectCmsControlByIdByPage } from "../../../redux/slices/cmsSettingsSlice";
import ReceiptShippingDetails from "./ReceiptShippingDetails";

const ConnectedReceiptShippingDetails = ({ controlId }) => {
    const {
        ENUMS: { DefaultView },
    } = constants;
    const receipt = useSelector(selectReceipt);
    const { transaction } = receipt;
    const { store } = transaction;
    const control = useSelector((state) =>
        selectCmsControlByIdByPage(
            controlId,
            DefaultView.STANDARD_REGISTRATION_RECEIPT,
            state,
        ),
    );

    const {
        options: { shippingDetailsLabel = "Shipping Details" },
    } = control;

    const translatedTransaction =
        store && Object.keys(store).length > 0
            ? translateTransaction(store)
            : {};

    const receiptShippingDetailsProps = {
        ...translatedTransaction,
        shippingDetailsLabel,
    };

    return <ReceiptShippingDetails {...receiptShippingDetailsProps} />;
};

ConnectedReceiptShippingDetails.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedReceiptShippingDetails;
